module.exports = __webpack_public_path__ + "static/7-c2ec55f87cf4b4e4a2b979dc00c2ff65.jpg";